import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { limitLines } from 'src/styles'
import { Wrapper as MenuItemImage } from '../menuItemImage/menuItemImage.styles'

type WrapperProps = {
  $active?: boolean
}

export const Wrapper = styled(Link)<WrapperProps>`
  height: 3.5rem;
  background-color: ${({ $active }) => ($active ? 'var(--structure-menu-item-bg)' : 'inherit')};
  font-weight: ${({ $active }) => ($active ? 'bold' : 'inherit')};
  transition: background ease 250ms;

  &:hover {
    background-color: var(--custom-color-lighter);

    ${MenuItemImage} {
      background-color: ${({ $active }) =>
        $active ? 'var(--structure-menu-item-bg)' : 'var(--custom-color-lighter)'};
    }
  }
`

Wrapper.displayName = 'Wrapper'

type TextProps = {
  $hasNotification?: boolean
  $isActive?: boolean
}

export const Text = styled.span<TextProps>`
  position: relative;

  span {
    ${limitLines(2)}
    word-break: break-word;
    font-weight: ${({ $hasNotification, $isActive }) =>
      $hasNotification || $isActive ? 'bold' : 'normal'};
  }

  ${({ $hasNotification }) =>
    $hasNotification &&
    css`
      &::after {
        background-color: var(--red) !important;
        content: '';
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 50%;
        position: relative;
        top: 50%;
        transform: translateX(-50%);
        flex-shrink: 0;
      }
    `}
`

Text.displayName = 'Text'
